export const SAFE_LINK_ATTRIBUTES = {
  rel: 'noopener noreferrer',
};

export const EXTERNAL_LINK_ATTRIBUTES = {
  ...SAFE_LINK_ATTRIBUTES,
  target: '_blank',
};

export const APP_STORE_URL_PREFIX = 'https://apps.apple.com/';

export const GOOGLE_PLAY_URL_PREFIX = 'https://play.google.com/store/apps/details?id=';
